<template>
  <div class="inline-flex w-full gap-1 rounded-lg bg-slate-100 p-1 sm:w-auto" role="tablist" aria-label="日报阶段">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      role="tab"
      class="min-w-[6.5rem] rounded-md px-4 py-2 text-sm font-medium transition-all duration-200"
      :class="modelValue === option.value ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'"
      :aria-selected="modelValue === option.value"
      @click="emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: String, default: 'plan' }
})

const emit = defineEmits(['update:modelValue'])
const options = [
  { value: 'plan', label: '计划' },
  { value: 'summary', label: '总结' }
]
</script>
